import React from 'react';
import { DownOutlined, FolderOpenOutlined, HomeOutlined, MoreOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Drawer, Empty, Flex, Dropdown, List, Pagination, Space, Tag, theme, Typography } from 'antd';

const { Text, Title } = Typography;
const PAGE_SIZE = 40;

const Mobile = ({ viewModel }) => {
  const { token } = theme.useToken();

  const footer = (
    <Flex vertical gap={8} style={{ width: '100%' }}>
      <Flex justify='space-between' align='center'>
        <Tag color={viewModel.selectedCount > 0 ? 'blue' : 'default'}>{viewModel.selectedCount} ảnh</Tag>
        <Text type='secondary' style={{ fontSize: 12 }}>Còn {viewModel.remainingSlots}/{viewModel.maxPhotos}</Text>
      </Flex>

      <Flex gap={8}>
        <Button style={{ flex: 1 }} onClick={viewModel.onCancel}>Đóng</Button>
        <Button style={{ flex: 1 }} type='primary' onClick={viewModel.confirmSelection} disabled={viewModel.selectedCount === 0}>Thêm ảnh</Button>
      </Flex>
    </Flex>
  );

  return (
    <Drawer
      title={
        <Flex vertical gap={0}>
          <Title level={5} style={{ margin: 0 }}>Chọn hình ảnh</Title>
          <Text type='secondary' style={{ fontSize: 12 }}>Nhấn vào ảnh để chọn nhanh</Text>
        </Flex>
      }
      open={viewModel.open}
      onClose={viewModel.onCancel}
      placement='bottom'
      height='88vh'
      styles={{
        header: { padding: '12px 12px 0 12px' },
        body: { padding: 12 },
        footer: { padding: 12 },
      }}
      footer={footer}
      maskClosable
    >
      <input type='file' accept='image/*' multiple onChange={viewModel.onFileChange} ref={viewModel.fileInputRef} style={{ display: 'none' }} />

      <Flex vertical gap={10}>
        <div style={{ overflowX: 'auto' }}>
          <Flex gap={4} wrap='nowrap'>
            {viewModel.breadcrumbFolders.map((item, index) => (
              <Button
                key={item.id}
                type={index === viewModel.breadcrumbFolders.length - 1 ? 'primary' : 'default'}
                size='small'
                icon={index === 0 ? <HomeOutlined /> : null}
                onClick={() => viewModel.openFolder(item.id)}
              >
                {item.name}
              </Button>
            ))}
          </Flex>
        </div>

        <Flex gap={6} wrap='wrap'>
          {viewModel.childFolders.map((item) => (
            <Button key={item.id} icon={<FolderOpenOutlined />} size='small' onClick={() => viewModel.openFolder(item.id)}>
              {item.name}
            </Button>
          ))}
          {viewModel.childFolders.length === 0 ? <Text type='secondary' style={{ fontSize: 12 }}>Không có thư mục con</Text> : null}
        </Flex>

        <Flex justify='space-between' align='center' gap={6}>
          <Space size={6}>
            {viewModel.currentFolder ? (
              <Dropdown menu={{ onClick: viewModel.onFolderActionClick, items: viewModel.folderActions }} trigger={['click']}>
                <Button icon={<MoreOutlined />} size='small' />
              </Dropdown>
            ) : null}
            <Button icon={<PlusOutlined />} size='small' onClick={() => viewModel.setShowCreateFolder(true)}>Folder</Button>
            <Button icon={<UploadOutlined />} size='small' onClick={() => viewModel.fileInputRef.current?.click()} loading={viewModel.uploading}>Upload</Button>
          </Space>

          <Space size={6}>
            {viewModel.selectedCount > 0 ? (
              <Dropdown menu={{ items: viewModel.bulkActionItems, onClick: viewModel.onBulkActionClick }}>
                <Button icon={<DownOutlined />} size='small' />
              </Dropdown>
            ) : null}
            <Button onClick={viewModel.clearSelection} disabled={viewModel.selectedCount === 0} size='small'>Bỏ chọn</Button>
          </Space>
        </Flex>

        <div style={{ maxHeight: '58vh', overflowY: 'auto' }}>
          {viewModel.pagedFiles.length === 0 ? (
            <Empty description='Chưa có ảnh' image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginBlock: 36 }} />
          ) : (
            <List
              dataSource={viewModel.pagedFiles}
              grid={{ gutter: 10, column: 3 }}
              renderItem={(file) => {
                const isSelected = Boolean(file.selected);

                return (
                  <List.Item key={file.id}>
                    <Card
                      hoverable
                      size='small'
                      onClick={() => viewModel.toggleImageSelected(file)}
                      style={{
                        borderColor: isSelected ? token.colorPrimary : token.colorBorderSecondary,
                        boxShadow: isSelected ? `0 0 0 2px ${token.colorPrimaryBorder}` : 'none',
                      }}
                      styles={{ body: { display: 'none' } }}
                      cover={
                        <div style={{ aspectRatio: '1 / 1', overflow: 'hidden', background: token.colorFillAlter }}>
                          <img src={file.sm_url || file.url} alt={file.name || 'image'} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                        </div>
                      }
                    />
                  </List.Item>
                );
              }}
            />
          )}
        </div>

        <Flex justify='end'>
          <Pagination
            current={viewModel.currentPage}
            pageSize={PAGE_SIZE}
            total={viewModel.totalFiles}
            onChange={(page) => viewModel.setCurrentPage(page)}
            showSizeChanger={false}
            size='small'
          />
        </Flex>
      </Flex>
    </Drawer>
  );
};

export default Mobile;
